import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const faqKeys = [0, 1, 2, 3, 4, 5].map((idx) => ({
  q: `butlerJob.faq.${idx}.question`,
  a: `butlerJob.faq.${idx}.answer`,
}));

function splitParagraphs(text: string): string[] {
  return text.split(/\n{2,}/);
}

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.faq.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.faq.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.faq.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="space-y-3">
          {faqKeys.map((faq, idx) => (
            <div key={idx} className="border border-background-200/60 bg-background-50">
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium pr-4">
                  {t(faq.q)}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-accent-500 text-sm transition-transform duration-300 ${
                      openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[1200px]' : 'max-h-0'
                }`}
              >
                {splitParagraphs(String(t(faq.a))).map((paragraph, pIdx) => (
                  <p
                    key={pIdx}
                    className="px-5 pb-5 text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">
          {t('butlerJob.faq.footer')}
        </p>
      </div>
    </section>
  );
}
